module.exports = __webpack_public_path__ + "static/media/found4.d678a9d5.png";